/* eslint-disable no-console */
// TODO: create debug logger that only logs when a flag is set.
function log(message, ...other) {
  if (console && console.log) {
    console.log(message, ...other);
  }
}

module.exports = log;



// WEBPACK FOOTER //
// ./static/js/v0/utilities/log.js